import { Container, OutlinedInput, styled } from "@mui/material";

export const MuiContainer = styled(Container)`
    margin-bottom: 1.875rem;
`;